import { Fragment, useEffect, useRef } from 'react';
import { useQuestionContext } from '../../context/chatbot/QuestionContextApi';
import { useHospitalContext } from '../../context/chatbot/HospitalContextApi';
import { useTranslation } from 'react-i18next';
import QuestionButton from './Conversation/QuestionButton';
import Answer from './Conversation/Answer';
import Question from './Conversation/Question';
import styled from 'styled-components';

export const TYPE_DEFINITION = {
  QUESTION: 0,
  SUCCESSFUL_ANSWER: 1,
  LOADING: 2,
  ERROR_ANSWER: 3,
};

export const AskedQuestionContainer = styled.div`
  height: 58vh !important;
  max-height: 59vh !important;
  overflow: auto !important;
  overflow-x: hidden;

  // sm
  @media only screen and (width >= 40rem) {
    height: 58vh;
    max-height: 59vh !important;
  }
  // md
  @media only screen and (width >= 48rem) {
    width: 80% !important;
  }
`;

function AskedQuestions() {
  const ref = useRef(null);
  const pageRef = useRef<HTMLDivElement | null>(null);
  const questionContext = useQuestionContext();
  const hospital = useHospitalContext();
  const { t } = useTranslation('chatbot');

  if (!questionContext) {
    throw new Error('There is no question context');
  }

  const {
    questionList,
    question: { content, isLoading, streamAnswer },
  } = questionContext;

  const scrollToBottom = () => {
    const container: any = ref.current;
    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [content]);

  return (
    <div ref={ref} className="h-full overflow-auto" id="target-container">
      <div className="grid grid-cols-4 grid-rows-2 md:gap-y-1.5 sm:gap-y-3">
        <div ref={pageRef} />
        {hospital!.questionButtonList.map((q, ind) => (
          <QuestionButton key={ind} id={ind}>
            {q}
          </QuestionButton>
        ))}
        {questionList
          .filter(
            (item) =>
              item.threadId === hospital!.hospitalInitialInformation.threadId &&
              item.title !== ''
          )
          .map((q) => (
            <Fragment key={q.key}>
              <Question qTitle={q.title} />
              <Answer
                ans={q.ans}
                type={
                  [t('pauseResponse'), t('errorInFetchingResponse')].includes(
                    q.ans
                  )
                    ? TYPE_DEFINITION.ERROR_ANSWER
                    : TYPE_DEFINITION.SUCCESSFUL_ANSWER
                }
                annotations={q.annotations}
                questionKey={q.key}
              />
            </Fragment>
          ))}
        {content && (
          <Fragment>
            <Question qTitle={content} initial={true} className="my-10" />
            <Answer
              ans={isLoading ? t('waitingForResponse') : streamAnswer}
              isLoading={isLoading}
              type={
                isLoading
                  ? TYPE_DEFINITION.LOADING
                  : TYPE_DEFINITION.SUCCESSFUL_ANSWER
              }
            />
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default AskedQuestions;
